import TwoOptionsSelectField from './TwoOptionsSelectField.component';

export default TwoOptionsSelectField;
